<!-- <template>
<b-container fluid>
    <PortalNavbar v-if="!isLoggedIn"></PortalNavbar>
    <b-container>
        
        <br/>
        <h2 class="text-primary">Privacy Policy</h2>
        <br/>
        <div class="row">

            <div class="col-md-12">
                <div align="justify">
                    
                    <p>
                        We maintain full privacy of your personal information shared with us. We never misuse any of your personal information. Our privacy policy is as given below:
                    </p>
                    <p>
                        <strong>1.  Collection and Sharing of customer information: </strong>
                        We collect information from you only after you agree to provide it. Any information you give us is held with care and security. This information is collected primarily to ensure that we ship your products without any hassles.
                        <br/>
                        We may collect your title, name, gender, email address, postal address, delivery address (if different), telephone number, mobile number, fax number, payment details or bank account details. All this information is processed securely for your protection.
                        <br/>
                        Your actual order details may be stored with us and you may access this information by logging into your account on the Site. You undertake to treat the personal access data confidentially and not make it available to unauthorized third parties.
                        <br/>
                        Under no circumstances do we rent, trade or share your personal information that we have collected with any other company for their marketing purposes without your consent. We reserve the right to communicate your personal information to any third party that makes a legally-compliant request for its disclosure.
                        </p>
                    <p>
                        <strong>2.  Intellectual Property Rights:: </strong>
                        All content included on this site, such as text, graphics, logos, button icons, images and software, is the property of CERISETECH SOLUTIONS PVT. LTD. All content on the Site that is not the property of CERISETECH SOLUTIONS PVT. LTD is used with permission.
                    </p>

                </div>
            </div>

        </div>

    </b-container>
</b-container>
</template>
<script>
import PortalNavbar from "@/components/PortalNavbar";

export default {
  components: { PortalNavbar },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script> -->

<!-- new changes -->

<template>
    <b-container fluid>
        <PortalNavbar v-if="!isLoggedIn"></PortalNavbar>
        <b-container class="policy-container">
            <br/>
            <h2 class="text-primary">Privacy Policy</h2>
            <br/>
            <div class="row">
                <div class="col-md-12">
                    <div class="policy-content" align="justify">
                        <p class="highlight">
                            We maintain full privacy of your personal information shared with us. We never misuse any of your personal information. Our privacy policy is as given below:
                        </p>
                        <p>
                            <strong>1. Collection and Sharing of customer information:</strong>
                            We collect information from you only after you agree to provide it. Any information you give us is held with care and security. This information is collected primarily to ensure that we ship your products without any hassles.
                            <br/>
                            We may collect your title, name, gender, email address, postal address, delivery address (if different), telephone number, mobile number, fax number, payment details or bank account details. All this information is processed securely for your protection.
                            <br/>
                            Your actual order details may be stored with us and you may access this information by logging into your account on the Site. You undertake to treat the personal access data confidentially and not make it available to unauthorized third parties.
                            <br/>
                            Under no circumstances do we rent, trade or share your personal information that we have collected with any other company for their marketing purposes without your consent. We reserve the right to communicate your personal information to any third party that makes a legally-compliant request for its disclosure.
                        </p>
                        <p>
                            <strong>2. Intellectual Property Rights:</strong>
                            All content included on this site, such as text, graphics, logos, button icons, images and software, is the property of CERISETECH SOLUTIONS PVT. LTD. All content on the Site that is not the property of CERISETECH SOLUTIONS PVT. LTD is used with permission.
                        </p>
                    </div>
                </div>
            </div>
        </b-container>
    </b-container>
    </template>
    
    <script>
    import PortalNavbar from "@/components/PortalNavbar";
    
    export default {
      components: { PortalNavbar },
      computed: {
        isLoggedIn() {
          return this.$store.getters.isLoggedIn;
        }
      }
    };
    </script>
    
    <style scoped>
    .policy-container {
      background-color: #f9f9f9;
      padding: 30px;
      border-radius: 15px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      margin-top: 20px;
    }
    
    .policy-content {
      font-family: 'Arial', sans-serif;
      color: #333;
      line-height: 1.8;
      background-color: #fff;
      padding: 20px;
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    
    .policy-content p {
      margin-bottom: 20px;
    }
    
    .policy-content .highlight {
      background-color: #e9f7fe;
      padding: 15px;
      border-left: 5px solid #007bff;
      font-weight: bold;
      color: #0056b3;
      border-radius: 5px;
    }
    
    .policy-content strong {
      color: #007bff;
    }
    
    h2.text-primary {
      font-weight: bold;
      text-align: center;
      margin-bottom: 30px;
      color: #0056b3;
    }
    
    a {
      color: #007bff;
      text-decoration: none;
    }
    
    a:hover {
      text-decoration: underline;
    }
    
    @media (max-width: 768px) {
      .policy-container {
        padding: 15px;
      }
    
      .policy-content {
        font-size: 14px;
        padding: 15px;
      }
    }
    </style>


// WEBPACK FOOTER //
// src/components/Policy.vue